import { Banner, Text } from '@betterment/samba-react';

const PackageNotFoundError: React.FC = () => {
  return (
    <Banner variant="critical" css={{ mt: 'space.300', mb: 'space.0' }}>
      <Banner.Content>
        <Text as="p">The plan documents could not be found.</Text>
      </Banner.Content>
    </Banner>
  );
};

export default PackageNotFoundError;
